<template>
  <div>
    <el-dialog
        :visible.sync="dialogVisible"
        title="付款方式100%"
        class="customer-edit"
        width="1000px"
        top="5vh"
        @close="onDialogClose">
      <el-button
          :loading="submitLoading"
          style="margin-bottom: 3%"
          type="primary"
          @click="handleSubmit">
        保存
      </el-button>
      <vm-table
          ref="vmTable"
          method="get"
          :filter.sync="filter"
          module="basic"
          url="customers/excludePMID"
          @select="selectTest"
          @select-all="selectAll">
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="客户名称">
              <el-input v-model.trim="filter.customerName" clearable/>
            </vm-search>
          </div>
        </template>
        <el-table-column type="selection" align="center" width="55"/>
        <el-table-column prop="customerName" align="center" label="客户名称"/>
      </vm-table>
      <el-table
          :data="tableData"
          border
          style="width: 100%">
        <el-table-column
            align="center"
            prop="customerName"
            label="选择的客户"/>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";

  export default {
    name:"PayMannerAllocation",
    components: {VmTable,VmSearch},
    data() {
      return {
        inspectionType: constant.inspectionType,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        tableData: [],
        filter: {
          pmid: "",
          customerName: "",
        },
        ruleValidate: {
        },
        idList: "",
      };
    },
    methods: {
      open(row) {
        this.filter.pmid = row;
        console.log(this.filter.pmid);
        this.dialogVisible = true;
        this.getData();
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      getData() {
        this.$http
          .get("basic", `customers/pmid/${this.filter.pmid}`)
          .then(resp => {
            this.tableData = resp;
          });
      },
      selectTest(selection) {
        this.idList = selection;
        console.log(this.idList);
      },
      selectAll(selection) {
        this.idList = selection;
      },
      handleSubmit() {
        this.newPkids=[];
        for(let item of this.idList) {
          this.newPkids.push(item.customerID);
        }
        let prams = {
          payMannerId:this.filter.pmid,
          ids: this.newPkids,
        };
        this.$http
          .post("basic", "payManners/payMannerRegister",prams)
          .then(() => {
            this.submitLoading = false;
            this.dialogVisible = false;
            this.$message.success("保存成功");
            this.$emit("save-success");
            this.idList = "";
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },
      onDialogClose() {
        this.submitLoading = false;
        this.contentLoading = false;
        this.idLists = [];
        this.filter.sapMaterialId = 0;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
